/* eslint-disable */ 
import { HashTable} from '@/utils/websocket'
import TMessageBox from '@/components/tMessageBox'

export const SampleAtlCtrl = function (clsid) {
    this.ready_func_ = null;
    this.callbacks_ = new HashTable();
    this.module_ = "IActiveXCtrl";
    if ('WebSocket' in window) {
        // FOCUSME: wss依赖https协议
        this.ws = new WebSocket("wss://127.0.0.1:1237")
    } else {
        throw "WebSocket not supported"
    }
    this.ws.onerror = function () {
        // TMessageBox.alert('Warning:Websocket connection failed!')
    }

    this.loadModule = function () {
        var msg = JSON.stringify({
            "MsgId": "LoadModule",
            "Module": this.module_
        });
        this.ws.onmessage = this._callback.bind(this);
        this.ws.send(msg);
    };
    this.loadModuleCallBack = function (result, response) {
        if (!result)
            throw result.Response;
        if (this.ready_func_) this.ready_func_();
    }.bind(this);

    this.callbacks_.add("LoadModule", this.loadModuleCallBack);

    this.exec = function (func, param, callback) {
        var msg_id = Object.id(callback).toString();
        this.callbacks_.add(msg_id, callback);
        var param_ = {
            "MsgId": msg_id,
            "Method": func + "|" + clsid
        };
        if (param) {
            param_["Param"] = JSON.stringify(param);
        }
        var msg = JSON.stringify(param_);
        console.warn({ msg })
        this.ws.send(msg);
    }


    this.ready = function (func) {
        this.ready_func_ = func;
    }

    this._callback = function (response) {
        var r = JSON.parse(response.data);
        var msg_id = r.MsgId;
        if (r.Result) {
            console.info(r.Response);
        } else {
            console.error('error1', r.Response);
        }
        if (!this.callbacks_.containsKey(msg_id)) {
            return;
        }
        console.log(this.callbacks_.getKeys());
        console.log(msg_id);
        var callback = this.callbacks_.getValue(msg_id);
        callback(r.Result, r.Response);
        this.callbacks_.remove(msg_id);
    }

    this.ws.onopen = this.loadModule.bind(this);


    this.GetSN = function (callback) {
        this.exec("GetSN", null, callback);
    }
    this.GetCertDN = function (callback) {
        this.exec("GetCertDN", null, callback);
    }


};
